/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { AdDesignShowDefaultsPathParams, AdDesignShowDefaultsResponse } from '../types/AdDesignShowDefaults'

/**
 * GET /organisations/:organisation/default-designs
 * @see backend/nexus/modules/Organisation/Http/Controllers/AdDesignController.php AdDesignController::showDefaults
 */
export async function adDesignShowDefaults(
	organisation: AdDesignShowDefaultsPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AdDesignShowDefaultsResponse>> {
	return axiosInstance.get(`/organisations/${organisation}/default-designs`, config)
}
